<script lang="ts">
  import PdpMoreInfoContent from './PdpMoreInfoContent.svelte';
  import PdpMoreInfoTabs from './PdpMoreInfoTabs.svelte';
  import { createEventDispatcher, onMount } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import {
    flixMediaDataAvailable,
    isTTL24DataAvailable,
    pdpMoreInfoActiveTab,
    productDetailMainData,
  } from '../store/pdp_store';
  import { initialize24TtlStream } from '../services/pdp-data-services';

  export let data: any;

  const { distributorId, flixmediaLanguage, modelNumber, flixInpage, flixButtonImage, fallbackLanguage, flixPrice } =
    getAppConfig();

  const dispatcher = createEventDispatcher();
  const handleOpenWriteReview = () => dispatcher('openWriteReview');

  $: if (
    $pdpMoreInfoActiveTab == 'Discover' &&
    data?.highlights == null &&
    !(data?.highlightsProvider == 'FLIX' && $flixMediaDataAvailable == true) &&
    !(data?.highlightsProvider == 'TTL_24' && $isTTL24DataAvailable == true) &&
    !($productDetailMainData.isMarketPlaceProduct == true && data?.description != null)
  ) {
    $pdpMoreInfoActiveTab = 'GeekyInfo';
  }

  $: if ($pdpMoreInfoActiveTab == 'GeekyInfo' && data?.productSpecifications == null && data?.classifications == null) {
    $pdpMoreInfoActiveTab = 'Reviews';
  }

  onMount(async () => {
    var discoverSection = document.querySelector('.discover-section');
    var iframe = discoverSection?.querySelector('iframe');

    if (iframe) {
      iframe.setAttribute('scrolling', 'no');
    }
    if (!data?.highlights) {
      if (data?.highlightsProvider === 'TTL_24') {
        initialize24TtlStream(data, modelNumber);
      }
    }
  });
</script>

<div class="hide-on-mobile">
  <div class="highlights-accordion-container">
    <PdpMoreInfoTabs {data} />
    <PdpMoreInfoContent
      {data}
      isDataLoaded={true}
      {distributorId}
      {flixmediaLanguage}
      {modelNumber}
      {flixInpage}
      {flixButtonImage}
      {fallbackLanguage}
      {flixPrice}
      enableRichMedia={true}
      onOpenWriteReview={handleOpenWriteReview}
    />
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  :global {
    .highlights-accordion-container {
      .material-icons {
        i {
          font-style: normal;
          color: $icon-only-icon-blue;
          font-size: 20px;
          @include desktop-min-width {
            font-size: 24px;
          }
        }
      }
    }

    .highlights-accordion-container .smui-paper__content {
      padding: 0 !important;
    }

    .highlights-accordion-container .smui-accordion__header::hover {
      background: $primary-white;
    }

    .highlights-accordion-container
      .smui-accordion
      .smui-accordion__panel
      > .smui-accordion__header
      .smui-accordion__header__title {
      display: flex;
      align-items: center;
      flex-grow: 1;
      justify-content: space-between;
      padding: 0;
    }

    .highlights-accordion-container .mdc-icon-button {
      height: 24px;
      width: 24px;
      padding: 0;
      margin-right: 16px;
      @include desktop-min-width {
        margin-left: 8px;
        margin-right: 51px;
      }
    }

    .highlights-accordion-container .mdc-ripple-surface::before {
      background-color: $primary-white !important;
    }
    .highlights-accordion-container .mdc-ripple-surface::after {
      background-color: $primary-white !important;
    }
    .highlights-accordion-container .smui-accordion .smui-accordion__panel--open {
      background-color: $primary-white !important;
    }
    .highlights-accordion-container .smui-paper.smui-paper--unelevated {
      background-color: $primary-white !important;
    }
    .highlights-accordion-container
      .smui-accordion
      .smui-accordion__panel.smui-accordion__panel--raised.smui-accordion__panel--elevation-z1::before {
      box-shadow: none !important;
    }
    .highlights-accordion-container .mdc-ripple-surface::before {
      background-color: $primary-white !important;
    }
    .highlights-accordion-container .mdc-ripple-surface::after {
      background-color: $primary-white !important;
    }
    .highlights-accordion-container .smui-accordion .smui-accordion__panel > .smui-accordion__header {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
    }
    .highlights-accordion-container
      .smui-accordion
      .smui-accordion__panel
      > .smui-accordion__header
      .smui-accordion__header__icon {
      margin-right: 0;
    }
  }

  .highlights-accordion-container {
    padding: 40px 0 24px 16px;
    @include desktop-min-width {
      padding: 40px 0 20px 20px;
    }
    .highlights-accordion-header {
      display: flex;
      justify-content: space-between;
    }
    ul.specs-tabs-list {
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    ul.specs-tabs-list {
      list-style: none !important;
      display: flex !important;
      justify-content: flex-start !important;
      border-bottom: 1px solid $secondary-gray-02 !important;
      margin: 0 0 16px 0;
      padding: 0;
      overflow: scroll;
      li {
        cursor: pointer;
        padding: 16px 8px;
        white-space: nowrap;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: $primary-black;
        @include desktop-min-width {
          padding: 16px 24px;
          font-size: 16px;
          line-height: 18px;
        }
        &.active {
          border-bottom: 2px solid $primary-blue;
          color: $primary-blue;
          font-weight: 700;
        }
      }
    }
    .product-key-and-specifications-header {
      padding: 0;
      &-text {
        color: $neutral-dark-01;
        font-size: 3.6rem;
        font-weight: 700;
        line-height: 52px;
        padding: 0;
        margin: 0;
        @media screen and (max-width: 728px) {
          font-size: 2rem;
          line-height: 2rem;
        }
      }
      .head-attributes {
        color: $neutral-dark-02;
        font-size: 1.8rem;
        font-weight: 400;
        padding-top: 0.8rem;

        @include desktop-max-width {
          width: 311px;
          overflow: hidden;
        }
        @media screen and (max-width: 728px) {
          font-size: 1.4rem;
          line-height: 1.6rem;
          padding-top: 0.2rem;
        }
      }
    }
    .product-desc {
      .heading {
        font-size: 18px;
        line-height: 16px;
        margin-bottom: 14px;
        font-weight: 700;
      }
      .description {
        margin: 0;
        font-size: 18px;
        line-height: 24px;
      }
    }
    .product-key-and-specifications-container {
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .collapse-info-text {
      color: $icon-only-icon-blue;
      font-size: 24px;
      font-weight: 500;
      line-height: 26px;
    }
    .text-icon-container {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: $icon-only-icon-blue;
      gap: 8px;
    }
    .product-key-and-specifications-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow-y: hidden;
      padding-top: 1.8rem;
      @include desktop-min-width {
        padding-top: 50px;
      }
    }
    .product-key-and-specifications-footer {
      text-align: center;
      font-size: 14px;
      line-height: 16px;
      margin: 0;
      margin-top: 24px;
      color: $icon-only-icon-blue;

      margin-right: 16px;
      padding: 0 53px;
      @include desktop-min-width {
        cursor: pointer;
        text-align: left;
        font-size: 24px;
        line-height: 28px;
        font-weight: 500;
        padding: 0;
        margin: 0;
        margin-top: 48px;
      }
    }
  }
</style>
